export const GUIDE_PINNED_TAG = 'DNU_PINNED'

export const GUIDE_FILTERS_TO_HIDE = [GUIDE_PINNED_TAG]
